<template>
  <div>
    <div class="buying-select">
      <div class="r-header">
        <div class="r-search">
          <div class="index-search-inner">
            <el-input class="index-search-item" placeholder="请输入关键词" v-model="searchValue">
              <el-select :popper-append-to-body="false" placeholder="请选择" slot="prepend" v-model="searchSelect">
                <el-option :key="item.index" :label="item.caption" :value="item.englishName" v-for="(item, index) in selectList"></el-option>
              </el-select>
              <el-button @click="transmit" slot="append">
                <div class="button-title">
                  <el-image :lazy="true" :src="require('../../assets/image/index/jiansuo.png')" fit="fill"></el-image>
                  <div>
                    检索
                  </div>
                </div>
              </el-button>
            </el-input>
          </div>
        </div>
      </div>
      <div class="buying-selectd">
        <div>已选择资源：</div>
        <div :key="index" v-for="(item, index) in selecdRource">
          <div class="buying-source">
            <div @click="sourceClick(item,index)" class="buying-source-close">
              <i class="el-icon-close"></i>
            </div>
            {{ item.title }}
          </div>
        </div>
      </div>
      <div :class="is_active.indexOf(item.id)!=-1?'is-active':''" :key="index" @click="sourceClick(item,index)" class="special-box" v-for="(item, index) in bookData">
        <div class="special-box-image">
          <el-image :src="require('../../assets/image/index/book.png')" fit="fill"></el-image>
        </div>
        <div class="special-box-text">
          <div class="text-header">
            <div class="header-category">古籍</div>
            <div class="header-title">{{item.title}}</div>
          </div>
          <div class="text-brief">
            <span style="color: #ccc;">简介:</span>
            {{item.introduction}}
          </div>
          <!-- <div class="text-button" >
              <svg  t="1644203588284" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3216" width="18" height="18" class="icon">
                  <path  d="M996.955405 145.54762c-1.815156-0.265292-18.696111-2.59707-48.78582-2.59707-56.241924 0-155.614757 8.377645-283.178365 52.30443 131.040331-74.211972 265.208316-80.983902 267.037436-80.983902a20.609007 20.609007 0 0 0-1.661566-41.190088c-8.531235 0.349069-167.134019 7.986688-313.882435 102.877481 110.975871-103.589581 273.278781-134.977824 275.415081-135.438594a20.650895 20.650895 0 0 0 16.517924-24.001954C905.862478 2.680846 881.204276 0.600398 884.443632 0c-11.826442 2.178188-272.008172 52.262542-372.567838 244.278167C411.106687 52.70935 151.399691 2.666884 139.615137 0.474733a20.609007 20.609007 0 0 0-7.442141 40.491951c2.164225 0.40492 164.760352 31.667498 275.722261 135.620111C261.035139 81.556374 102.181027 73.876867 93.649791 73.541761a20.609007 20.609007 0 1 0-1.647603 41.190088c1.843082 0.083776 136.192583 6.604377 267.442355 81.137492-127.745124-44.010562-227.243622-52.444058-283.541396-52.444058-30.089708 0-46.998589 2.359703-48.869596 2.624996A30.941436 30.941436 0 0 0 0.685857 178.960461l51.341001 684.900407a30.969361 30.969361 0 0 0 29.74064 28.609658c254.359266 9.11767 409.946097 124.142737 411.481999 125.273719a30.91351 30.91351 0 0 0 32.393561 3.029915 30.508591 30.508591 0 0 0 7.274588-5.04055c19.226695-13.683487 169.745051-115.192619 409.3457-123.75178a30.955398 30.955398 0 0 0 29.726677-28.595695l51.313076-684.91437a30.955398 30.955398 0 0 0-26.361657-32.924145zM480.920396 937.05356c-65.443371-36.680123-193.090755-93.55037-369.300556-105.027743L64.677102 205.433819c3.448797-0.083776 7.162887-0.167553 11.170194-0.167553 71.209983 0 216.939118 14.437475 405.087063 108.909386z m431.44872-105.502476c-176.209801 11.379635-303.857186 68.347621-369.314519 105.01378V313.756769c188.147945-94.56965 333.905006-108.909386 405.114988-108.909385q5.990016 0 11.170194 0.125665z m0 0" p-id="3217">

                  </path>
              </svg>
              <div>
                  在线阅读
              </div>
          </div> -->
        </div>
      </div>
    </div>
    <div class="buying-payment">
      <div class="buying-seclec">
        <div>权限级别：</div>
        <el-select v-model="permLevel">
          <el-option key="READ" label="阅读" value="r"></el-option>
          <el-option key="DOWNLOAD" label="下载" value="d"></el-option>
        </el-select>
      </div>
      <!-- 暂时保留 别删 -->
      <!-- <div class="payment-box">
          <div class="payment-item" v-for="(item, index) in oncePrice.price" :key="index" :class="permice == item.permice?'is-active':''" @click="buying(item)">
              <div class="paymen-item-box" >
                  <div class="payment-item-title">
                      {{ item.title }}
                  </div>

              </div>
          </div>
      </div> -->
      <!-- 暂时保留结束 -->
      <!-- <div class="buying-image">
          <div class="image-box">
              <div id="qrcode" ref="qrcode"></div>
          </div>
          <div class="title">请使用微信/支付宝扫码支付</div>
      </div>
      <div style="display: flex;justify-content: center;align-items: center;padding-bottom: 4rem;">
          <el-button class="btn" @click="paymentFinished">支付完成</el-button>
      </div> -->
      <div style="display: flex;justify-content: center;align-items: center;">
        <el-button @click="codeClick" class="btn" size="default" type="primary">点击购买</el-button>
      </div>
      <el-dialog
        :before-close="handleClose"
        :visible.sync="dialogVisible"
        custom-class="dialog-class"
      >
        <!--
            booksNotToBePurchased:'',
            booksToBePurchased:''
        -->
        <div class="dialog-title">已购买资源</div>
        <el-table :data="priceYes.booksNotToBePurchased" :header-cell-style="{fontSize: '0.833rem',color: '#333',backgroundColor: '#f3f3f3',height:'2.083rem'}" style="margin-bottom:2.064rem">
          <!-- <el-table-column key="1"  label="权限级别">
              <template slot-scope="scope">
                  {{ permLevel=='r'?'阅读':permLevel=='d'?'下载':'商用' }}
              </template>
          </el-table-column> -->
          <el-table-column key="1" label="资源id" prop="bookId">

          </el-table-column>
          <el-table-column key="2" label="题名" prop="title">

          </el-table-column>
          <el-table-column key="3" label="作者" prop="author">

          </el-table-column>
        </el-table>
        <div class="dialog-title">待购买资源</div>
        <el-table :data="priceYes.booksToBePurchased" :header-cell-style="{fontSize: '0.833rem',color: '#333',backgroundColor: '#f3f3f3',height:'2.083rem'}" style="margin-bottom: 3.125rem;">
          <el-table-column key="4" label="资源id" prop="bookId">

          </el-table-column>
          <el-table-column key="5" label="题名" prop="title">

          </el-table-column>
          <el-table-column key="6" label="作者" prop="author">

          </el-table-column>
        </el-table>
        <div class="payment-item-price">
          <div class="price-f">应付金额</div>
          <div class="price-p" style="margin: 0 0.2rem;">{{ priceYes.price / 100 }}</div>
          <div class="price-d" style="min-width:1.25rem;">元</div>
        </div>
        <div class="buying-image">
          <div class="image-box">
            <div id="qrcode" ref="qrcode"></div>
          </div>
          <div class="title">请使用微信/支付宝扫码支付</div>
        </div>
        <div style="display: flex;justify-content: center;align-items: center;padding-bottom: 4rem;">
          <el-button @click="paymentFinished" class="btn">支付完成</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import {listSearchParam, mainSearch} from '../../api/resource'
  import {purchaseBooks, queryPayResult} from '../../api/buying'
  import QRCode from 'qrcodejs2'

  export default {
    name: 'PortalVaried',

    data() {
      return {
        bookData: [],
        searchValue: '',
        searchSelect: '',
        // 检索条件
        searchList: [],
        selectList: [],
        pageEsParams: [],

        // 已选择资源
        selecdRource: [],
        is_active: [],

        dialogVisible: false,

        permLevel: 'r',
        oncePrice: {
          price: [
            {
              title: '一天浏览权',
              permice: '1'
            },
            {
              title: '包月',
              permice: '30'
            },
            {
              title: '包年',
              permice: '365'
            },
            {
              title: '终身',
              permice: '-1'
            },
          ],
        },
        permice: '1',
        url: '',
        tradeNo: '',
        priceYes: [],

      };
    },

    mounted() {
      this.getSearchParams()
    },

    methods: {
      // 检索条件
      getSearchParams() {
        listSearchParam({
          typeId: this.$store.state.typeId
        }).then(res => {
          if (res && res.data.data) {
            res = res.data.data
            //去掉不显示的高级检索值
            res.map(data => {
              const arr = ['书号', '是否公開', '元數據模版', "元数据模板", '分類', 'ID', '主从', '审核状态', 'OAI公开状态', 'OCR识别状态', '子分類', '冊數', '图片名列表', '全文信息', '子分类', '分类', '馆藏地址', '购买价格', '中图分类号', '简介', '出版发行', '原定书价', '时长']
              const num = arr.findIndex(e => e == data.name)
              if (num < 0) {
                this.searchList.push(data)
              }
              return data
            })
            var hash = {}
            var arr = this.searchList.reduce(function (item, next) {
              hash[next.name] ? '' : hash[next.name] = true && item.push(next);
              return item
            }, [])
            this.selectList = JSON.parse(JSON.stringify(arr))
            this.searchSelect = this.searchList[0].englishName
          }
        })
      },
      transmit() {
        if (this.searchValue == '') {
          this.$message({
            message: '请输入搜索内容',
            type: "error",
          });
          return
        }
        if (this.searchSelect == '全部') {
          let params = JSON.parse(JSON.stringify(this.selectList))
          params.map((data) => {
            data.searchValue = this.searchValue
            data.searchRelation = "0"
            data.searchType = "0"
            delete data.dicType
            delete data.name
            delete data.caption
            return data
          })
          this.pageEsParams = params
        } else {
          this.pageEsParams = [{
            searchName: this.searchSelect,
            searchRelation: "0",
            searchType: "0",
            searchValue: this.searchValue
          }]
        }
        this.getData()
      },
      getData() {
        let params = {
          typeId: this.$store.state.typeId,
          index1: 'ancientbook',
          esParams: [],
          limit: 2,
        }
        //默认审核和主书检索
        params.esParams.push(
          {
            searchName: "examineState",
            searchRelation: 1,
            searchType: 1,
            searchValue: "1",
          })
        params.esParams.push(...this.pageEsParams)
        mainSearch(params).then(res => {
          if (res.data.code == 200) {
            this.bookData = JSON.parse(JSON.stringify(res.data.data.list))
          }
        })
      },
      sourceClick(item, index) {
        if (this.is_active.indexOf(item.id) == -1) {
          this.is_active.push(item.id)
          this.selecdRource.push(item)
        } else {
          let indexs = this.is_active.findIndex(e => e == item.id)
          this.is_active.splice(indexs, 1)
          this.selecdRource.splice(indexs, 1)
        }
      },
      handleClose(done) {
        this.$refs.qrcode.innerHTML = ''
        done();
      },
      async codeClick() {
        let data = await this.chaseBooks(this.permice)
        this.dialogVisible = true
        this.priceYes = JSON.parse(JSON.stringify(data))
        this.url = data.qrCodeUrl
        this.tradeNo = data.tradeNo
        this.$nextTick(() => {
          // 创建二维码
          this.qrcode()
        })

      },
      // 查询价格
      chaseBooks(e) {
        return new Promise((provide, inject) => {
          purchaseBooks({
            bookIds: this.is_active,
            permLevel: this.permLevel == 'r' ? 'READ' : 'DOWNLOAD',
            daysFor: e
          }).then(res => {
            if (res.data.code == 200) {
              provide(res.data.data)
            } else if (res.data.code == 400) {
              this.$message({
                message: res.data.message,
                type: 'error'
              })
            }
          })
        })
      },
      // 选择价格
      async buying(item) {
        if (item.permice === this.permice) return
        this.permice = item.permice
        // this.$refs.qrcode.innerHTML=''
        // this.permice = item.permice
        // let data = await this.chaseBooks(this.permice)
        // this.url = data.qrCodeUrl
        // this.tradeNo = data.tradeNo
        // this.$nextTick(()=>{
        //     // 创建二维码
        //     this.qrcode()
        // })
      },
      // 生成支付二维码
      qrcode() {
        const fontSize = getComputedStyle(window.document.documentElement)['font-size'].split('px')[0]
        let qrcode = new QRCode('qrcode', {
          width: 8.333 * fontSize, // 设置宽度，单位像素
          height: 8.333 * fontSize, // 设置高度，单位像素
          text: this.url // 设置二维码内容或跳转地址
        })
      },
      // 查询支付是否成功
      paymentFinished() {
        queryPayResult({
          tradeNo: this.tradeNo
        }).then(res => {
          if (res.data.code == 200) {
            if (res.data.data.trxstatus === '0000') {
              this.$message({
                message: "支付成功，请稍后",
                type: "success",
              });
              setTimeout(() => {
                this.$router.push({
                  path: '/resource/detail',
                  query: {
                    bookId: this.priceYes.booksToBePurchased[0].bookId
                  }
                })
              }, 1000);
            } else {
              this.$message({
                message: res.data.data.desc,
                type: "error",
              });
            }
          }
        })
      }
    },
  };
</script>

<style lang="less" scoped>
  .buying-select {
    background-color: #fff;
    padding: 0 1.563rem;
    padding-bottom: 2.083rem;

    .r-header {
      width: 100%;
      height: 6.646rem;
      display: flex;
      align-items: center;
      justify-content: center;

      .r-search {
        display: flex;
        justify-content: center;
        align-items: center;

        .index-search-inner {
          border-radius: 0.313rem;
          display: flex;
          justify-content: center;

          .index-search-item {
            width: 36.458rem;
            height: 2.604rem;

            /deep/ .el-input-group__prepend {
              background-color: #ffffff;

              .el-select {
                background-color: #ffffff;
                color: #b1222b;
                font-size: 1rem;
                margin: -5px -20px;

                .el-input {
                  .el-input__inner {
                    width: 7.292rem;
                    height: 1.54rem;
                    border-right: 0.052rem solid #b1222b;
                    text-align: center;
                    line-height: 1.54rem;
                  }

                  .el-input__suffix {
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    .el-input__suffix-inner {
                      .el-select__caret.el-input__icon.el-icon-arrow-up {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        transform: rotateZ(0);
                      }

                      .el-select__caret.el-input__icon.el-icon-arrow-up::before {
                        content: "";
                        appearance: none; // 去除select默认的下拉图标
                        border-top: 7px solid #b1222b;
                        border-right: 7px solid transparent;
                        border-left: 7px solid transparent;
                        transition: transform .3s;
                        transform: rotateZ(0);
                      }

                      .el-select__caret.el-input__icon.el-icon-arrow-up.is-reverse::before {
                        content: "";
                        appearance: none; // 去除select默认的下拉图标
                        border-top: 7px solid #b1222b;
                        border-right: 7px solid transparent;
                        border-left: 7px solid transparent;
                        transform: rotateZ(180deg);
                      }
                    }
                  }
                }

                /deep/ .el-input.is-focus {
                  .el-input__suffix {
                    .el-input__suffix-inner {
                      transform: rotateZ(180deg)
                    }
                  }
                }

                .el-select-dropdown.el-popper {
                  .el-select-dropdown__item {
                    color: #333;
                  }

                  .el-select-dropdown__item.hover {
                    color: #b1222b;
                  }

                }
              }
            }

            /deep/ .el-input__inner {
              width: 29.115rem;
              height: 2.604rem;
              border-left: none;

              &:focus {
                border-color: #DCDFE6;
              }
            }

            .el-input-group__append {
              .el-button {
                width: 6.771rem;
                height: 2.604rem;
                background-color: #b1222b;
                border-top-right-radius: 0.313rem;
                border-bottom-right-radius: 0.313rem;

                .button-title {
                  display: flex;
                  justify-content: center;

                  .el-image {
                    margin-right: 0.729rem;
                  }

                  font-size: 1.042rem;
                  color: #ffffff;
                }
              }
            }

          }
        }
      }
    }

    .buying-selectd {
      display: flex;
      align-items: center;
      margin-bottom: 1.563rem;
      // height: 3.729rem;
      .buying-source {
        position: relative;
        padding: 0.677rem 1.615rem 0.573rem 1.615rem;
        background-color: #ffffff;
        border-radius: 0.313rem;
        border: solid 0.052rem #cccccc;
        font-size: 0.833rem;
        letter-spacing: 0.016rem;
        color: #333333;
        margin-right: 1.563rem;

        .buying-source-close {
          position: absolute;
          width: 0.885rem;
          height: 0.885rem;
          border-radius: 50%;
          border: solid 0.052rem #cccccc;
          background-color: #fff;
          cursor: pointer;
          right: -0.4425rem;
          top: -0.4425rem;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 0.6rem;
        }
      }
    }

    .special-box {
      width: 100%;
      height: 11.563rem;
      border: solid 0.052rem #cccccc;
      display: flex;
      padding-left: 2.188rem;
      padding-right: 1.188rem;
      padding-top: 1.198rem;
      padding-bottom: 1.094rem;
      margin-bottom: 1.042rem;

      &.is-active {
        border: none;
        background: url('../../assets/image/buying/kuang.png') no-repeat;
        background-size: contain;
      }

      &:last-child {
        margin-bottom: unset;
      }

      .special-box-image {
        margin-right: 1.042rem;

        .el-image {
          width: 6.198rem;
          height: 9.129rem;
        }
      }

      .special-box-text {
        width: 100%;
        position: relative;

        .text-header {
          display: flex;
          align-items: center;
          margin-bottom: 0.833rem;

          .header-category {
            width: auto;
            height: 1.342rem;
            line-height: 1.342rem;
            background-color: #9aca2a;
            border-radius: 7px;
            color: #fff;
            padding: 0 0.3rem;
            font-size: 0.8rem;
            margin-right: 0.26rem;
          }
        }

        .text-brief {
          font-size: 0.725rem;
          line-height: 1.3rem;
          overflow: hidden;
          text-overflow: ellipsis; //多出部分用...代替
          display: -webkit-box; //定义为盒子模型显示
          -webkit-line-clamp: 4; //用来限制在一个块元素显示的文本的行数
          -webkit-box-orient: vertical; //从上到下垂直排列子元素（设置伸缩盒子的子元素排列方式）
        }

        .text-button {
          position: absolute;
          align-items: center;
          bottom: 0rem;
          font-size: 0.625rem;
          min-width: 4.479rem;
          display: flex;
          padding: 4px 12px;
          border-radius: 5px;
          border: 1px solid #dcdfe6;
          cursor: pointer;

          svg {
            margin-right: 0.3rem;
          }
        }

        .text-button:hover {
          color: #fff;
          background-color: #b2262f;
          border-color: #b2262f;

          svg {
            path {
              fill: #fff !important;
            }

          }
        }
      }
    }
  }

  .buying-payment {
    margin-top: 1.042rem;
    width: 62.5rem;
    padding-bottom: 3.125rem;
    background-color: #ffffff;
    border-radius: 0.833rem;

    .buying-seclec {
      display: flex;
      align-items: center;
      padding-top: 2.083rem;
      padding-left: 1.563rem;

      div {
        font-size: 1.146rem;
        letter-spacing: 0.021rem;
        color: #333333;
      }

      /deep/ .el-select {
        width: 7.292rem;
        height: 2.083rem;

        .el-input__inner {
          text-align: center;
          height: 2.083rem;

          &:focus {
            border-color: #C0C4CC;
          }
        }
      }
    }

    .payment-box {
      display: flex;
      justify-content: space-between;
      padding: 2.604rem 4.167rem 2.064rem 4.167rem;

      .payment-item {
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        width: 10.938rem;
        height: 5.208rem;
        background: url('../../assets/image/buying/allkuang.png') no-repeat;
        background-size: cover;

        &:hover, &.is-active {
          background: url('../../assets/image/buying/allkuang1.png') no-repeat;
          background-size: cover;
          box-shadow: none;
          border: unset
        }

        .paymen-item-box {
          text-align: center;

          .payment-item-title {
            font-size: 1.146rem;
            color: #333333;
          }

          .payment-item-price {
            display: flex;
            align-items: baseline;
            justify-content: center;
            text-align: center;
            margin-top: 2.188rem;

            .price-f, .price-d {
              font-size: 0.833rem;
              color: #333333;
            }

            .price-p {
              font-size: 3rem;
              color: #333333;
            }
          }
        }
      }
    }

    .buying-image {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      .image-box {
        width: 8.333rem;
        height: 8.333rem;
      }

      .title {
        margin-bottom: 2rem;
        margin-top: 1rem;
      }

    }

    .btn {
      width: 9.375rem;
      height: 2.604rem;
      background-color: #b1222b;
      border-color: #b1222b;
      border-radius: 0.313rem;
      font-size: 1.146rem;
      letter-spacing: 0.021rem;
      color: #ffffff;
    }

    /deep/ .el-dialog__wrapper {
      .dialog-class {
        border-radius: 0.521rem;
        width: 46.354rem;

        .el-dialog__header {
          padding: unset;
        }

        .el-dialog__body {
          .dialog-title {
            font-size: 0.833rem;
            color: #333333;
            margin-bottom: 1.042rem;
          }

          .payment-item-price {
            display: flex;
            align-items: baseline;
            justify-content: center;
            text-align: center;
            margin-top: 2.188rem;
            margin-bottom: 1.51rem;

            .price-f, .price-d {
              font-size: 0.833rem;
              color: #333333;
            }

            .price-p {
              font-size: 3rem;
              color: #b1222b;
            }
          }
        }

      }
    }
  }
</style>
